import { render, staticRenderFns } from "./CategoryList.vue?vue&type=template&id=5e527374"
import script from "./CategoryList.vue?vue&type=script&lang=ts"
export * from "./CategoryList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports